import React, { useContext, useState, useEffect } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import VariableContext from "../contexts/VariableContext";
import FetchingFreq from "../contexts/FetchingFreq";
import config from "../configs/config";
import OpenProperties from "./OpenProperties";
import MyChartComponent from "./MyChartComponent";
import FrequencyTableComponent from "./FrequencyTableComponent";
import HoverDropdown from "./HoverDropdown";
import MultiResponse from "./MultiResponse";
import DataGrid from "./DataGrid";
import MultiDataGrid from "./MultiDataGrid";
import Grid3DData from "./Grid3DData";
import CrosstabTable from "./CrosstabTable";
import CustomizedVariable from "./CustomizedVariable";
import PropertiesComponent from "./PropertiesComponent";
import * as XLSX from "xlsx";
import { useAuth } from "../providers/AuthProvider";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import "./styles/DataTables.css";

import {
  faFolder,
  faFile,
  faTable,
  faChartBar,
  faArrowLeft,
  faGear,
  faDownload,
  faGauge,
  faBuilding,
  faWeightScale,
  faPeopleRoof,
  faHouse,
  faLaptopFile,
  faChargingStation,
  faUpload,
  faPlus,
  faGlobe,
  faFileExport,
  faArrowsLeftRight,
  faRefresh,
} from "@fortawesome/free-solid-svg-icons";
import Loader from "./Loader";

function DataTables() {
  const {
    dataGroup,
    setdataGroup,
    selectedVariables,
    banners,
    setBanners,
    setSelectedVariables,
    projectId,
    savedWeightings,
    saveCurrentWeighting,
    currentSelectedVariablesset,
    setcurrentSelectedVariablesset,
    setSavedWeightings,
    weightedCounts,
    weightingStats,
    setWeightingStats,
    setWeightedCounts,
    targetPercentages,
    setTargetPercentages,
    currentSelectedVariables,
    setCurrentSelectedVariables,
    frequencyData,
    setFrequencyData,
    setSelectedClient,
    setSelectedProject,
    selectedProject,
    selectedClient,
    powner
  } = useContext(VariableContext);

  const {
    setMessage,
    setActivePage,
    handleTitleClick,
    selectedTitle,
    setSelectedTitle,
    refreshData,
    setRefreshData,
    selectedBanner,
    setselectedBanner,
    selectedWeights,
    setSelectedWeights,
    selectedVariable,
    setSelectedVariable,
    loading,
    setLoading, isPropertiesShow, setIsPropertiesShow
  } = useContext(FetchingFreq);
  const { user } = useAuth();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isAModalOpen, setIsaModalOpen] = useState(false);

  const [exportType, setExportType] = useState("both");
  const [sigText, setsigText] = useState(false);
  const [exportOptions, setExportOptions] = useState([
    { text: "Export Percentages", value: "percent" },
    { text: "Export Frequencies", value: "frequency" },
    { text: "Export Both", value: "both" },
  ]);
  const allExportTypes = [
    { type: "Uncle", text: "Uncle Tables", feature: "uncle" },
    { type: "Quantum", text: "Quantum Tables", feature: "quantum" },
    { type: "Wincross", text: "Wincross Tables", feature: "wincross" },
  ];
  const [exportfeatures, setExportfeatures] = useState([]);
  const [crosstabDisplayData, setCrosstabDisplayData] = useState(null);
  const [activeTab, setActiveTab] = useState(
    banners && banners.length > 0 ? banners[0]?.name || "" : ""
  );
  const [displayMode, setDisplayMode] = useState("table");
  const [isCrossTab, setisCrossTab] = useState(false);
  const [exportOption, setExportOption] = useState(false);
  const [fileName, setFileName] = useState("");
  const [displaySettings, setDisplaySettings] = useState({
    showFrequency: true,
    showPercent: true,
  });
  const [isControlPanelOpen, setIsControlPanelOpen] = useState(false);
  const [allowedExports, setAllowedExports] = useState([]);

  useEffect(() => {
    setActivePage("tables");
  }, []);

  useEffect(() => {
    const organization = user?.user?.organization || user?.organization;

    if (organization) {
      if (
        organization.datatables_exports &&
        Array.isArray(organization.datatables_exports) &&
        organization.datatables_exports.length > 0
      ) {
        setAllowedExports(organization.datatables_exports);

        const filteredExports = allExportTypes.filter((exportType) =>
          organization.datatables_exports.includes(exportType.feature)
        );
        setExportfeatures(filteredExports);
      } else {
        console.warn(
          "⚠️ No datatables_exports found, defaulting to all exports"
        );
        setAllowedExports(allExportTypes.map((item) => item.feature));
        setExportfeatures(allExportTypes);
      }
    } else {
      console.warn("⚠️ No organization found, allowing all exports");
      setAllowedExports(allExportTypes.map((item) => item.feature));
      setExportfeatures(allExportTypes);
    }
  }, [user]);

  // Function to scan and update varName locations
  const scanAndUpdateVarNameLocations = () => {
    if (!window.confirm("Are you sure you want to update all varName locations? This action cannot be undone.")) {
      return;
    }

    setLoading(true);

    try {
      const updatedDataGroup = { ...dataGroup };
      let nextLocation = 11; // Start from 11
      let updatedCount = 0;
      let skippedCount = 0;

      // Get all keys in dataGroup
      const keys = Object.keys(updatedDataGroup);

      // Sort keys by order property
      const sortedKeys = keys.sort((a, b) => {
        const orderA = updatedDataGroup[a]?.order || updatedDataGroup[a]?._order || 0;
        const orderB = updatedDataGroup[b]?.order || updatedDataGroup[b]?._order || 0;
        return orderA - orderB;
      });

      // console.log("Processing keys in order:", sortedKeys.map(key => ({
      //   key,
      //   order: updatedDataGroup[key]?.order || updatedDataGroup[key]?._order || 0
      // })));

      sortedKeys.forEach(key => {
        const variable = updatedDataGroup[key];

        // Check if variable has varName property (array) with entries
        if (variable && variable.varName && Array.isArray(variable.varName)) {
          // Check variable type
          const variableType = variable.type || "";
          const isStringType = variableType.toLowerCase().includes("string");
          const isStringGrid = variableType.toLowerCase().includes("stringgrid");

          // Skip String and StringGrid types
          // if (isStringType || isStringGrid) {
          //   console.log(`Skipping ${key} - ${variableType} (order: ${variable.order || variable._order || 0})`);
          //   skippedCount++;
          //   return;
          // }

          // Skip if varName array is empty
          if (variable.varName.length === 0) {
            return;
          }

          // Process each varName entry in the array
          const updatedVarNames = variable.varName.map(varNameObj => {
            if (!varNameObj) return varNameObj;

            const currentLocation = varNameObj.Location || "";

            // Skip if no location property or empty location
            if (!varNameObj.Location || currentLocation.trim() === "") {
              // console.log(`No location for ${key} - ${varNameObj.Name || 'unnamed'}`);
              return varNameObj;
            }

            let newLocation = "";

            if (currentLocation.includes(":")) {
              // If location is in format "start:end", preserve the width
              const parts = currentLocation.split(":");
              if (parts.length === 2) {
                const start = Number(parts[0]);
                const end = Number(parts[1]);

                // Check if both start and end are valid numbers
                if (!isNaN(start) && !isNaN(end) && start <= end) {
                  const width = end - start + 1;

                  // Set new location with same width
                  const newEnd = nextLocation + width - 1;
                  newLocation = `${nextLocation}:${newEnd}`;

                  // Update next location for the next variable
                  nextLocation = newEnd + 1;
                  updatedCount++;

                  // console.log(`Order ${variable.order || variable._order || 0}: ${key} - ${varNameObj.Name || 'unnamed'} - ${currentLocation} -> ${newLocation}`);
                } else {
                  // If invalid format, keep original
                  // console.log(`Invalid location format for ${key}: ${currentLocation}`);
                  newLocation = currentLocation;
                }
              } else {
                // Invalid format (more than one colon)
                newLocation = currentLocation;
              }
            } else {
              // If no range, check if it's a single number
              const numLocation = Number(currentLocation);
              if (!isNaN(numLocation) && currentLocation.trim() !== "") {
                newLocation = nextLocation.toString();
                nextLocation += 1;
                updatedCount++;

                // console.log(`Order ${variable.order || variable._order || 0}: ${key} - ${varNameObj.Name || 'unnamed'} - ${currentLocation} -> ${newLocation}`);
              } else {
                // If not a valid number, keep original
                newLocation = currentLocation;
              }
            }

            // Return updated varName object
            return {
              ...varNameObj,
              Location: newLocation
            };
          });

          // Only update if there were changes
          if (JSON.stringify(variable.varName) !== JSON.stringify(updatedVarNames)) {
            updatedDataGroup[key] = {
              ...variable,
              varName: updatedVarNames
            };
          }
        }
      });

      // Update the state
      setdataGroup(updatedDataGroup);

      // Show summary
      alert(`✅ Updated ${updatedCount} varName locations successfully!\nSkipped ${skippedCount} String/StringGrid types.\nNext available location: ${nextLocation}`);

    } catch (error) {
      console.error("Error updating varName locations:", error);
      alert("❌ Error updating locations. Please check console for details.");
    } finally {
      setLoading(false);
    }
  };


  const closeModalAndUpdateButtons = () => {
    setIsModalOpen(false);
    handleTitleClick(selectedTitle);
  };

  const handleShowProperties = () => {
    setIsPropertiesShow(!isPropertiesShow);
  };

  const handleDisplaySettingsChange = (e) => {
    setDisplaySettings({
      ...displaySettings,
      [e.target.name]: e.target.checked,
    });
  };

  const handleFileUpload = (e) => {
    const file = e.target.files[0];
    if (!file) return;

    setFileName(file.name);

    const reader = new FileReader();
    reader.onload = (evt) => {
      const data = new Uint8Array(evt.target.result);
      const workbook = XLSX.read(data, { type: "array" });

      const summarySheet = XLSX.utils.sheet_to_json(
        workbook.Sheets["Summary"],
        { header: 1 }
      );
      const detailsSheet = XLSX.utils.sheet_to_json(
        workbook.Sheets["Details"],
        { header: 1 }
      );

      const newDataGroup = parseExcelToDataGroup(summarySheet, detailsSheet);
      setdataGroup(newDataGroup);
    };
    reader.readAsArrayBuffer(file);
  };

  const parseExcelToDataGroup = (summarySheet, detailsSheet) => {
    const dataGroup = {};

    const [headerRow, ...dataRows] = summarySheet;
    for (const row of dataRows) {
      const key = row[0];
      const item = {};
      headerRow.forEach((header, i) => {
        if (header === "key") return;
        try {
          item[header] = JSON.parse(row[i]);
        } catch {
          item[header] = row[i];
        }
      });
      dataGroup[key] = item;
    }

    let i = 0;
    while (i < detailsSheet.length) {
      const keyRow = detailsSheet[i];
      if (!keyRow || !keyRow[0]) {
        i++;
        continue;
      }

      const key = keyRow[0];
      const subHeader = detailsSheet[i + 1]?.[0];
      const headers = detailsSheet[i + 2];
      const values = [];

      let j = i + 3;
      while (j < detailsSheet.length && detailsSheet[j]?.length > 0) {
        const row = detailsSheet[j];
        const obj = {};
        headers.forEach((h, idx) => {
          obj[h] = row[idx];
        });
        values.push(obj);
        j++;
      }

      if (!dataGroup[key]) dataGroup[key] = {};
      dataGroup[key][subHeader] = values;

      i = j + 1;
    }

    return dataGroup;
  };

  const exportFrequencies = async (type = "both") => {
    const endpoint = "/export_frequencies";
    const requestData = { projectId: projectId };
    if (type !== "both") {
      requestData.type = type;
    }
    requestData.type = type;
    requestData.sigTest = sigText;

    try {
      const response = await fetch(`${config.API_BASE_URL}${endpoint}`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(requestData),
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const blob = await response.blob();
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;
      a.download =
        type === "both"
          ? `frequency_data_${projectId}.xlsx`
          : `frequency_data_${projectId}_${type}.xlsx`;
      document.body.appendChild(a);
      a.click();
      a.remove();
      window.URL.revokeObjectURL(url);
    } catch (error) {
      console.error("Export error:", error);
    }
  };
  if (!selectedProject || Object.keys(selectedProject).length === 0) {
    alert("Project details not loaded yet");
    setLoading(false);
    return;
  }

  if (!selectedClient || Object.keys(selectedClient).length === 0) {
    alert("Client details not loaded yet");
    setLoading(false);
    return;
  }

  if (!powner) {
    alert("Project owner missing");
    setLoading(false);
    return;
  }

  const downloadTxtFile = (e) => {
    setLoading(true);
    setExportOption(e);

    fetch(`${config.API_BASE_URL}/generate-file`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        projectId,
        dataList: dataGroup,
        banners,
        user: powner,
        project: JSON.stringify(selectedProject),
        client: JSON.stringify(selectedClient),
        type: e,
      }),
    })
      .then((response) => response.json())
      .then((data) => {
        // console.log("Success:", data);
        setLoading(false);
        alert("Successfull");
      })
      .catch((error) => {
        console.error("Error:", error);
        alert("Error, Contact Administrator");
        setLoading(false);
      });
  };

  const handleTabChange = (tabName) => {
    if (tabName === "") {
      setActiveTab("");
      setselectedBanner(null);
    } else {
      const check = banners.filter((x) => x.name === tabName)[0];
      setActiveTab(check.name);
      setselectedBanner(check);
    }
  };

  const handleExportTypeChange = (event) => {
    setExportType(event);
    exportFrequencies(event);
  };

  const toggleModal = () => {
    setIsModalOpen((prev) => !prev);
  };

  const atoggleModal = () => {
    setIsaModalOpen((prev) => !prev);
  };

  const acloseModalAndUpdateButtons = () => {
    setIsaModalOpen(false);
  };

  const exportToExcel = () => {
    const rows = [];
    const headersSet = new Set();

    for (const key in dataGroup) {
      const item = dataGroup[key];
      const row = { key };

      for (const prop in item) {
        if (
          ![
            "Rows",
            "values",
            "reverseGrid",
            "grid",
            "Cols",
            "varName",
            "rankSumary",
            "valueLabels",
          ].includes(prop)
        ) {
          if (typeof item[prop] === "object" && item[prop] !== null) {
            row[prop] = JSON.stringify(item[prop]);
          } else {
            row[prop] = item[prop];
          }
          headersSet.add(prop);
        }
      }
      rows.push(row);
    }

    const headers = ["key", ...Array.from(headersSet)];
    const summaryData = [headers];
    for (const row of rows) {
      const rowData = headers.map((header) => row[header] ?? "");
      summaryData.push(rowData);
    }

    const summarySheet = XLSX.utils.aoa_to_sheet(summaryData);

    const detailData = [];

    for (const key in dataGroup) {
      const item = dataGroup[key];
      for (const items in item) {
        if (
          [
            "Rows",
            "values",
            "reverseGrid",
            "grid",
            "Cols",
            "varName",
            "rankSumary",
            "valueLabels",
          ].includes(items)
        ) {
          const subHeaders = item[items];
          if (Array.isArray(subHeaders) && subHeaders.length > 0) {
            detailData.push([key]);
            detailData.push([items]);

            const columnHeaders = Object.keys(subHeaders[0]);
            detailData.push(columnHeaders);

            for (const obj of subHeaders) {
              const row = columnHeaders.map((col) => obj[col] ?? "");
              detailData.push(row);
            }

            detailData.push([]);
          }
        }
      }
    }

    const detailSheet = XLSX.utils.aoa_to_sheet(detailData);

    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, summarySheet, "Summary");
    XLSX.utils.book_append_sheet(workbook, detailSheet, "Details");

    XLSX.writeFile(workbook, "DataGroupExport.xlsx");
  };

  return (
    <>
      <div>
        {/* Control Panel */}
        <div
          className={`control-panel ${isControlPanelOpen ? "open" : "closed"}`}
        >
          <div className="control-section">
            <h4>Data Management</h4>
            <div className="control-group">
              <button
                className="btn btn-primary"
                onClick={() => exportToExcel()}
                title="Export to Excel"
              >
                <FontAwesomeIcon icon={faFileExport} />
                <span>Export Excel</span>
              </button>

              <div className="file-upload-wrapper">
                <label className="file-upload-label">
                  <FontAwesomeIcon icon={faUpload} />
                  <span>Choose File</span>
                  <input
                    type="file"
                    accept=".xlsx, .xls"
                    onChange={handleFileUpload}
                    className="file-input"
                  />
                </label>
                {fileName && <span className="file-name">{fileName}</span>}
              </div>

              {/* NEW BUTTON: Scan and Update varName Locations */}
              <button
                className="btn btn-warning"
                onClick={scanAndUpdateVarNameLocations}
                title="Scan all varNames and update locations starting from 11"
                disabled={loading}
              >
                <FontAwesomeIcon icon={faArrowsLeftRight} />
                <span>Update Locations Numeric Only</span>
              </button>
            </div>
          </div>

          <div className="control-section">
            <h4>Analysis Tools</h4>
            <div className="control-group">
              <button
                className="btn btn-outline"
                onClick={() => toggleModal()}
                title="Update Properties"
              >
                <FontAwesomeIcon icon={faGear} />
                <span>Properties</span>
              </button>

              <button
                className="btn btn-outline"
                onClick={() => atoggleModal()}
                title="Append Variable"
              >
                <FontAwesomeIcon icon={faPlus} />
                <span>Append Variable</span>
              </button>
              <div className="toggle-group">
                <label className="toggle-item">
                  <input
                    type="checkbox"
                    checked={sigText}
                    onChange={(e) => setsigText(e.target.checked)}
                  />
                  <span className="toggle-slider"></span>
                  <span className="toggle-text">Sig Test</span>
                </label>

                <label className="toggle-item">
                  <input
                    type="checkbox"
                    checked={refreshData}
                    onChange={(e) => setRefreshData(e.target.checked)}
                  />
                  <span className="toggle-slider"></span>
                  <span className="toggle-text">Auto Refresh</span>
                </label>
              </div>
            </div>
          </div>

          <div className="control-section">
            <h4>Display Settings</h4>
            <div className="control-group">
              <HoverDropdown
                handleTabChange={handleTabChange}
                text="Select Banner"
                exportfeatures={banners}
                feature={2}
              />
              <HoverDropdown
                setSelectedWeights={setSelectedWeights}
                text="Select Weights"
                exportfeatures={savedWeightings}
                feature={3}
              />
              {/* <HoverDropdown
                downloadTxtFile={downloadTxtFile}
                text="Export Type"
                exportfeatures={exportfeatures}
                feature={1}
              /> */}
              <div className="hover-dropdown">
                <span
                  className="hover-text"
                  onClick={() => downloadTxtFile("Quantum")}
                  title="Export Quantum Tables"
                >
                  Export Quantum
                </span>
              </div>
              <HoverDropdown
                handleExportTypeChange={handleExportTypeChange}
                text="Export Tables"
                exportfeatures={exportOptions}
                feature={4}
              />
            </div>
          </div>
        </div>
        {!isPropertiesShow ? (
          <div className="data-tables-container">
            {/* Header Section */}

            <div className="page-header">
              <h2>Frequency Data: {selectedTitle}</h2>
              <div className="header-actions">
                <button
                  className={`btn btn-toggle ${
                    isControlPanelOpen ? "active" : ""
                  }`}
                  onClick={() => setIsControlPanelOpen(!isControlPanelOpen)}
                  title={
                    isControlPanelOpen
                      ? "Hide Control Panel"
                      : "Show Control Panel"
                  }
                >
                  <FontAwesomeIcon icon={faGear} />
                </button>

                <button
                  className="btn btn-secondary"
                  onClick={() => handleShowProperties()}
                  title="Global Settings"
                >
                  <FontAwesomeIcon icon={faGlobe} />
                  <span>Global</span>
                </button>
              </div>
            </div>

            {/* Data Display Area */}
            <div className="data-display-area">
              <>
                <div className="data-content">
                  {!isCrossTab &&
                    frequencyData &&
                    (frequencyData.type === "SingleResponse" ||
                      frequencyData.type === "Numeric") &&
                    displayMode === "table" && (
                      <FrequencyTableComponent
                        freq_table={frequencyData}
                        displaySettings={displaySettings}
                      />
                    )}
                  {!isCrossTab &&
                    frequencyData &&
                    frequencyData.type === "Multiple2DGrid" &&
                    displayMode === "table" && (
                      <MultiResponse
                        varProperties={frequencyData}
                        displaySettings={displaySettings}
                      />
                    )}
                  {!isCrossTab &&
                    frequencyData &&
                    (frequencyData.type === "Single2DGrid" ||
                      frequencyData.type === "Numeric2DGrid") &&
                    displayMode === "table" && (
                      <DataGrid
                        gridData={frequencyData}
                        displaySettings={displaySettings}
                      />
                    )}
                  {!isCrossTab &&
                    frequencyData &&
                    (frequencyData.type === "Multiple3DGrid" ||
                      frequencyData.type === "Single3DGrid") &&
                    displayMode === "table" && (
                      <MultiDataGrid
                        gridData={frequencyData}
                        displaySettings={displaySettings}
                      />
                    )}
                  {!isCrossTab &&
                    frequencyData &&
                    frequencyData.type === "Numeric3DGrid" &&
                    displayMode === "table" && (
                      <Grid3DData
                        gridData={frequencyData}
                        displaySettings={displaySettings}
                      />
                    )}
                  {displayMode === "chart" &&
                    frequencyData &&
                    Object.entries(frequencyData).map(
                      ([varName, freq], index) => (
                        <div key={index}>
                          <h3>{varName}</h3>
                          <MyChartComponent frequencyData={freq} />
                        </div>
                      )
                    )}
                  {isCrossTab && crosstabDisplayData && (
                    <CrosstabTable crosstab={crosstabDisplayData} />
                  )}
                </div>
              </>
            </div>

            {/* Modals */}
            <OpenProperties
              isOpen={isModalOpen}
              onClose={closeModalAndUpdateButtons}
              setdataGroup={setdataGroup}
              dataGroup={dataGroup}
              selectedKey={selectedTitle}
              selectedVariable={selectedVariable}
              setSelectedVariable={setSelectedVariable}
              projectId={projectId}
            />

            <CustomizedVariable
              isOpen={isAModalOpen}
              onClose={acloseModalAndUpdateButtons}
              setcurrentSelectedVariablesset={setcurrentSelectedVariablesset}
              dataGroup={dataGroup}
              projectId={projectId}
            />
          </div>
        ) : (
          <div className="properties-view">
            {/* Header with Global Settings button visible in properties view */}
            <div className="page-header" style={{ marginBottom: "24px" }}>
              <h2>Global Settings</h2>
              <div className="header-actions">
                <button
                  className={`btn btn-toggle ${
                    isControlPanelOpen ? "active" : ""
                  }`}
                  onClick={() => setIsControlPanelOpen(!isControlPanelOpen)}
                  title={
                    isControlPanelOpen
                      ? "Hide Control Panel"
                      : "Show Control Panel"
                  }
                >
                  <FontAwesomeIcon icon={faGear} />
                </button>
              </div>
            </div>

            {/* Back button kept for convenience */}
            <button
              className="btn btn-back"
              onClick={() => handleShowProperties()}
              style={{ marginBottom: "24px" }}
            >
              <FontAwesomeIcon icon={faArrowLeft} />
              <span>Back to Tables</span>
            </button>
            <PropertiesComponent
              setdataGroup={setdataGroup}
              selectedVariable={selectedVariable}
              selectedKey={selectedTitle}
              dataGroup={dataGroup}
              setSelectedVariable={setSelectedVariable}
              projectId={projectId}
            />
          </div>
        )}
      </div>
      {loading && <Loader loading={loading} />}
    </>
  );
}

export default DataTables;